import { mapCollection } from '../../utils/collection.utils';
import { FilteredPolls } from '../filtered-polls';
import { PollBuilder } from './poll.builder';

export class FilteredPollsBuilder {
    static fromJson(json) {
        return (json)
            ? new FilteredPolls(
                json.totalItems,
                json.currentPage,
                PollBuilder.fromList(json.polls)
            )
            : null;
    }

    static fromList(list) {
        return (Array.isArray(list)) ? mapCollection(FilteredPollsBuilder.fromJson, list) : [];
    }
}
